// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1NXQO","hiddenElements":"Header_hiddenElements__2glJg","search":"Header_search__3yWri","dark":"Header_dark__2lnBp","wrapper":"Header_wrapper__3m9Ip"};